(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bikebook-booking-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function runCounter(el) {
      if (el.dataset.counted === 'true') return;
      el.dataset.counted = 'true';
      var target = parseInt(el.dataset.count || '0', 10);
      var start = performance.now();
      var duration = 650;
      function tick(now) {
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(target * eased).toString();
        if (progress < 1) requestAnimationFrame(tick);
        else el.textContent = target.toString();
      }
      requestAnimationFrame(tick);
    }
    function initCounters(root) {
      var counters = Array.prototype.slice.call((root || document).querySelectorAll('.bikebook-count'));
      if (!counters.length) return;
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { runCounter(entry.target); observer.unobserve(entry.target); }
          });
        }, { threshold: 0.35 });
        counters.forEach(function (el) { observer.observe(el); });
      } else { counters.forEach(runCounter); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCounters(document); }); else initCounters(document);
    document.addEventListener('shopify:section:load', function (event) { initCounters(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-short-films-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialiseThumbnails = (root) => {
    root.querySelectorAll("[data-gallery-video-card]").forEach((card) => {
      const video = card.querySelector("video");
      if (!video || card.dataset.thumbnailInitialised === "true") return;

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      const showSelectedFrame = () => {
        const requestedTime = Number(card.dataset.thumbnailTime || 0);
        if (!Number.isFinite(video.duration)) return;

        const safeTime = Math.min(
          Math.max(requestedTime, 0),
          Math.max(video.duration - 0.1, 0)
        );

        if (safeTime > 0) {
          video.pause();
          video.removeAttribute("poster");
          video.currentTime = safeTime;
        }

        card.dataset.thumbnailInitialised = "true";
      };

      if (video.readyState >= 1) {
        showSelectedFrame();
      } else {
        video.addEventListener("loadedmetadata", showSelectedFrame, { once: true });
        video.load();
      }
    });
  };

  const initialisePage = () => initialiseThumbnails(document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialisePage, { once: true });
  } else {
    initialisePage();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialiseThumbnails(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    initialiseThumbnails(event.target.closest(".gsf") || document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
